import { render, staticRenderFns } from "./viewPlan.vue?vue&type=template&id=1f1ff333&scoped=true"
import script from "./viewPlan.vue?vue&type=script&lang=js"
export * from "./viewPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ff333",
  null
  
)

export default component.exports